
export const initialPartyValue = {
    pty_acc_mul_compy_yn: 'yes',
    pty_acc_fin_doc_yn: 'yes',
    pty_acc_stf_yn: 'yes',
    pty_acc_ext_yn: 'yes',
    pty_acc_agr_yn: 'yes',
    pty_acc_addr_yn: 'yes',
    pty_acc_cont_yn: 'yes',
    pty_acc_rem_doc_yn: 'yes',
}

export const initialPartyValueSuperAdmin = {

    pty_acc_mul_compy_yn: 'yes',
    pty_acc_fin_doc_yn: 'yes',
    pty_acc_stf_yn: 'yes',
    pty_acc_ext_yn: 'yes',
    pty_acc_agr_yn: 'yes',
    pty_acc_addr_yn: 'yes',
    pty_acc_cont_yn: 'yes',
    pty_acc_rem_doc_yn: 'yes',
}